import React, { useEffect, useState } from "react";
import {
  ScrollView,
  StyleSheet,
  Text as RNText,
  TouchableOpacity,
  View as RNView,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import { CORES, sombraCard } from "../../../../template/Etapas/styles";
import { corTextoSobre, gradienteHero } from "../../../../theme/cores";
import { Box, Flex, Text, useColorMode, useToast } from "native-base";

import { useNavigation, useRoute } from "@react-navigation/native";
import createStyles from "./styles";
import Template from "../../../../template/Index";
import { CommonActions } from "@react-navigation/native";
import { useTheme } from "../../../../../ThemeProvider";
import {
  AntDesign,
  FontAwesome,
  MaterialCommunityIcons,
} from "@expo/vector-icons";
import { Card } from "primereact/card";

export default function ComprovantePtgOnline({}) {
  const { primaryColor, isMobile, configEmpresa } = useTheme();

  const [parametros, setParametros] = useState<any>(null);

  const toast = useToast();
  const navigation = useNavigation();
  const route = useRoute();

  const { colorMode } = useColorMode();
  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa)
  );

  const styles = createStyles(getConfigEmpresa.coresPWA);

  useEffect(() => {
    const parametros_recebidos = route.params as any;
    setParametros(parametros_recebidos?.dados);
  }, []);

  const getIconByTitle = (title: string) => {
    const titleLower = title.toLowerCase();

    if (titleLower.includes("detalhes") || titleLower.includes("agendamento")) {
      return "calendar-check";
    } else if (titleLower.includes("pagamento")) {
      return "cash-multiple";
    } else if (
      titleLower.includes("políticas") ||
      titleLower.includes("politicas")
    ) {
      return "shield-check";
    } else if (titleLower.includes("cancelamento")) {
      return "cancel";
    } else {
      return "information"; // ícone padrão
    }
  };

  function renderLinhaFinal() {
    return (
      <Box width={"100%"}>
        <Text style={styles.heading}>Políticas de Cancelamento</Text>

        <Box style={styles.container}>
          <Text style={styles.dateLabelFinal}>
            Se precisar, você tem a opção de cancelar ou alterar seu agendamento
            até 1 hora antes do horário estipulado. Para isso, acesse sua conta
            e siga as instruções disponíveis.
          </Text>
        </Box>
      </Box>
    );
  }
  function renderLinha(
    titulo_principal: String,
    subtitulo: String,
    valor: String,
    isValor: Boolean = false,
    top_menor: Boolean = false
  ) {
    return (
      <Box width={"100%"}>
        <Flex direction="row" alignItems="center">
          <Text
            style={[
              styles.heading,
              {
                marginTop: top_menor ? 5 : 20,
                borderBottomColor:
                  getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao,
              },
            ]}
            fontSize="lg"
          >
            <MaterialCommunityIcons
              name={getIconByTitle(titulo_principal.toString())}
              size={24}
              color={getConfigEmpresa.coresPWA.corFontePrimaria}
              style={{ marginRight: 8 }}
            />{" "}
            {titulo_principal}
          </Text>
        </Flex>

        <Box style={styles.container}>
          {isValor ? null : (
            <Text style={styles.dateLabel} fontSize="md">
              {subtitulo}
            </Text>
          )}
          <Text style={styles.dateValue} fontSize="md">
            {valor}
          </Text>
        </Box>
      </Box>
    );
  }

  function finalizar() {
    if (typeof window !== "undefined") {
      window.history.pushState({}, "", "/");
    }

    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "TabNavigator", params: { screen: "Inicio" } }],
      })
    );
  }

  // ---------------- Somente apresentação (layout novo) ----------------
  const corPrincipal: string = primaryColor || "#006400";
  const corTextoPrincipal = corTextoSobre(corPrincipal);

  const linhasDetalhe: { rotulo: string; valor: any }[] = [
    {
      rotulo: "Valor",
      valor: parametros?.valor != null ? "R$ " + parametros?.valor : null,
    },
    { rotulo: "Cobrança", valor: parametros?.periodicidade },
    { rotulo: "Primeira cobrança", valor: parametros?.data_primeira_cobranca },
    { rotulo: "Última cobrança", valor: parametros?.data_ultima_cobranca },
    { rotulo: "Próxima cobrança", valor: parametros?.data_proxima_cobranca },
  ].filter((linha) => linha.valor != null && linha.valor !== "");

  return (
    <RNView style={stylesNovo.container}>
      <ScrollView
        style={{ flex: 1, width: "100%" }}
        contentContainerStyle={{ alignItems: "center", paddingBottom: 24 }}
      >
        {/* Topo de celebração */}
        <div
          style={{
            position: "relative",
            overflow: "hidden",
            width: "100%",
            boxSizing: "border-box",
            paddingTop: 44,
            paddingBottom: 90,
            paddingLeft: 20,
            paddingRight: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: corPrincipal,
            backgroundImage: gradienteHero(corPrincipal),
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
          }}
        >
          <div style={circulo(220, -60, -70)} />
          <div style={circulo(140, -20, -30)} />

          <RNView style={stylesNovo.anelCheck}>
            <RNView style={stylesNovo.circuloCheck}>
              <Feather name="check" size={34} color={corPrincipal} />
            </RNView>
          </RNView>

          <RNText style={[stylesNovo.titulo, { color: corTextoPrincipal }]}>
            {parametros?.titulo ? parametros?.titulo : "Assinatura\nativada!"}
          </RNText>
          <RNText style={[stylesNovo.subtitulo, { color: corTextoPrincipal }]}>
            Agora é só agendar.
          </RNText>
        </div>

        <RNView style={stylesNovo.largura}>
          <RNView style={[stylesNovo.ticket, sombraCard]}>
            <RNView style={stylesNovo.topoTicket}>
              <RNView style={{ flex: 1 }}>
                <RNText style={stylesNovo.rotuloPlano}>PLANO</RNText>
                <RNText style={stylesNovo.nomePlano}>
                  {parametros?.nome_plano}
                </RNText>
              </RNView>
              {parametros?.id_assinatura != null && (
                <RNView style={stylesNovo.chipCodigo}>
                  <RNText style={stylesNovo.textoChipCodigo}>
                    Nº {parametros?.id_assinatura}
                  </RNText>
                </RNView>
              )}
            </RNView>

            {linhasDetalhe.map((linha, indice) => (
              <RNView
                key={linha.rotulo}
                style={[
                  stylesNovo.linha,
                  indice === linhasDetalhe.length - 1 && {
                    borderBottomWidth: 0,
                  },
                ]}
              >
                <RNText style={stylesNovo.rotuloLinha}>{linha.rotulo}</RNText>
                <RNText style={stylesNovo.valorLinha}>
                  {String(linha.valor)}
                </RNText>
              </RNView>
            ))}
          </RNView>
        </RNView>
      </ScrollView>

      <RNView style={stylesNovo.rodape}>
        <RNView style={stylesNovo.largura}>
          <TouchableOpacity
            activeOpacity={0.85}
            style={[stylesNovo.botao, { backgroundColor: corPrincipal }]}
            onPress={() => {
              finalizar();
            }}
          >
            <Feather name="home" size={18} color={corTextoPrincipal} />
            <RNText
              style={[stylesNovo.textoBotao, { color: corTextoPrincipal }]}
            >
              Voltar ao início
            </RNText>
          </TouchableOpacity>
        </RNView>
      </RNView>
    </RNView>
  );
}

function circulo(
  tamanho: number,
  top: number,
  right: number
): React.CSSProperties {
  return {
    position: "absolute",
    width: tamanho,
    height: tamanho,
    top,
    right,
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.12)",
    pointerEvents: "none",
  };
}

const stylesNovo = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    backgroundColor: CORES.fundo,
  },
  largura: {
    width: "100%",
    maxWidth: 560,
    paddingHorizontal: 16,
  },
  anelCheck: {
    width: 96,
    height: 96,
    borderRadius: 48,
    padding: 10,
    backgroundColor: "rgba(255,255,255,0.12)",
    marginBottom: 18,
  },
  circuloCheck: {
    flex: 1,
    borderRadius: 40,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
  titulo: {
    fontSize: 28,
    lineHeight: 32,
    fontWeight: "800",
    textAlign: "center",
  },
  subtitulo: {
    fontSize: 14,
    marginTop: 8,
    opacity: 0.85,
    textAlign: "center",
  },
  ticket: {
    marginTop: -60,
    padding: 18,
    borderRadius: 20,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
  },
  topoTicket: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: CORES.borda,
  },
  rotuloPlano: {
    fontSize: 11,
    fontWeight: "800",
    letterSpacing: 1.5,
    color: CORES.subtitulo,
  },
  nomePlano: {
    fontSize: 20,
    fontWeight: "800",
    color: CORES.titulo,
    marginTop: 2,
  },
  chipCodigo: {
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 12,
    backgroundColor: "#F2EDE4",
  },
  textoChipCodigo: {
    fontSize: 12,
    fontWeight: "700",
    color: CORES.subtitulo,
  },
  linha: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: CORES.borda,
  },
  rotuloLinha: {
    fontSize: 13,
    color: CORES.subtitulo,
  },
  valorLinha: {
    flexShrink: 1,
    textAlign: "right",
    fontSize: 14,
    fontWeight: "700",
    color: CORES.titulo,
  },
  rodape: {
    width: "100%",
    alignItems: "center",
    backgroundColor: CORES.card,
    paddingTop: 14,
    paddingBottom: 18,
    borderTopLeftRadius: 22,
    borderTopRightRadius: 22,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -4 },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 8,
  },
  botao: {
    height: 52,
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  textoBotao: {
    fontSize: 16,
    fontWeight: "700",
  },
});
